export type Locale = 'us' | 'uk' | 'other'

export default function getLocale(currency: string = 'usd'): Locale {
  const language = navigator?.language?.toLowerCase() ?? 'en-us'
  const checkCurrency = currency?.toLowerCase()

  if (language === 'en-gb' || checkCurrency === 'gbp') {
    return 'uk'
  }

  if (language === 'en-us' || checkCurrency === 'usd') {
    return 'us'
  }

  return 'other'
}
